import React, { useState, useEffect } from 'react';
import css from './PendingAcceptanceWorkerCard.module.css';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { ReactComponent as GoToArrow } from '../../assets/svg/ArrowRight.svg';
import { ReactComponent as BlankProfileImg } from '../../assets/svg/Blank_Profile.svg';

import GoToButton from '../GoToButton/GoToButton';
import NamedLink from '../NamedLink/NamedLink';
import { createSlug } from '../../util/urlHelpers';
import moment from 'moment';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { FormattedMessage } from 'react-intl';
import { findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import { listingTypes } from '../../marketplace-custom-config';
import classNames from 'classnames';
import { isArray, isEmpty } from 'lodash';
import Button, { InlineTextButton } from '../Button/Button';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { ReactComponent as Star } from '../../assets/svg/star.svg';
import {
  STATUS_ACCEPTED,
  STATUS_DECLINED,
  STATUS_PENDING,
  fetchWorkerStatus,
} from './PendingAcceptanceWorkerCard.duck';
import IconSpinner from '../IconSpinner/IconSpinner';
import { useRef } from 'react';
import axios from 'axios';
import { apiBaseUrl } from '../../util/api';

function PendingAcceptanceWorkerCardComponent(props) {
  const {
    workerDetails,
    userNativeLang,
    listingId,
    history,
    from,
    fetchStatusInProgress,
    workerStatus,
    fetchStatusError,
    onfetchWorkerStatus,
    removeWorkerFromListing,
    currentUser,
    currentTx,
    removeWorkerInProgress,
  } = props;
  const [status, setStatus] = useState('');
  const [rating, setRating] = useState(0);
  const callRef = useRef();
  const currentDBObj = currentTx?.[`${workerDetails?.id?.uuid}+${listingId}`]?.currentTx;

  useEffect(() => {
    callRef.current = true;
    if (workerDetails?.id?.uuid) {
      axios
        .post(`${apiBaseUrl()}/api/reviews/get-total-rating`, {
          workerId: workerDetails?.id?.uuid,
          to: 'worker',
        })
        .then(res => {
          setRating(res.data);
        });
    }
  }, []);
  useEffect(() => {
    if (!status && workerDetails?.id?.uuid && callRef.current === true) {
      onfetchWorkerStatus({
        listingId,
        workerId: workerDetails?.id?.uuid,
      })
        .then(() => {
          callRef.current = false;
        })
        .catch(err => {
          callRef.current = true;
        });
    }
  }, [workerDetails]);
  useEffect(() => {
    setStatus(workerStatus?.[`${workerDetails?.id?.uuid}+${listingId}`]?.status);
  }, [workerStatus]);
  const workerName = `${workerDetails?.attributes?.profile?.displayName}...`;
  const id = workerDetails?.id?.uuid;
  const slug = createSlug(workerName);
  const jobStartDates = workerDetails?.attributes?.profile?.publicData?.jobExperiences?.map(
    m => m?.jobStartDate
  );

  const jobEndDates = workerDetails?.attributes?.profile?.publicData?.jobExperiences?.map(
    m => m?.jobEndDate
  );

  const momentJobStartDate = jobStartDates && moment(jobStartDates).locale(userNativeLang);
  const momentJobEndDate = jobEndDates && moment(jobEndDates).locale(userNativeLang);

  const differenceInYears = jobStartDates?.map((date, indx) => {
    const yearsWorkedTillNow = momentJobEndDate
      ? moment(jobEndDates[indx]).diff(jobStartDates[indx], 'years')
      : moment().diff(jobStartDates, 'years');

    return yearsWorkedTillNow;
  });

  const totalYearsWorkedTillNow =
    differenceInYears?.length > 0
      ? differenceInYears?.reduce((a, b) => {
          return a + b;
        })
      : null;
  const profileImageUrl = workerDetails?.profileImage?.attributes?.variants?.default?.url;
  return (
    <div
      className={classNames(css.workerDetailCard, css.aplliedWorkerDetail)}
      key={workerDetails?.id?.uuid}
      onClick={() => {
        const params = { id: id, slug: slug };

        from === 'BusinessDashboard' || from === 'ListingApplied'
          ? history.push(
              createResourceLocatorString(
                'WorkerProfileBusinessViewPage',
                routeConfiguration(),
                params,
                {}
              ),
              { from: from }
            )
          : history.push(
              createResourceLocatorString(
                'WorkerProfileAdminViewPage',
                routeConfiguration(),
                params,
                {}
              )
            );
      }}
    >
      <div className={css.workerDetailDiv}>
        <div>
          {profileImageUrl ? (
            <img src={profileImageUrl} alt={workerName} className={css.profileImg} />
          ) : (
            <BlankProfileImg className={css.profileImg} />
          )}
        </div>
        <div className={css.dataDiv}>
          <div className={css.topBottomRow}>
            <span>{workerName}</span>
            <div>
              <Star />

              <span>{rating}</span>
            </div>
          </div>
          {totalYearsWorkedTillNow ? (
            <span className={css.yrOfExp}>{totalYearsWorkedTillNow} years of experience</span>
          ) : null}
        </div>
      </div>

      <span className={css.hDivider} />

      {/* when worker is not accepted */}
      <span className={css.actnspn}>
        <span>
          {removeWorkerInProgress === workerDetails?.id?.uuid ? (
            <IconSpinner />
          ) : fetchStatusError ? (
            <FormattedMessage id="EditListingPoliciesForm.showListingFailed" />
          ) : status === STATUS_ACCEPTED ? (
            <FormattedMessage id="InboxPage.stateAccepted" />
          ) : status === STATUS_DECLINED ? (
            <FormattedMessage id="InboxPage.stateDeclined" />
          ) : status === STATUS_PENDING ? (
            <FormattedMessage id="InboxPage.statePending" />
          ) : null}
        </span>
        {status !== STATUS_ACCEPTED &&
          !fetchStatusError &&
          typeof removeWorkerFromListing === 'function' && (
            <InlineTextButton
              className={css.askForStaffbtn2}
              inProgress={fetchStatusInProgress}
              tyoe="button"
              onClick={e => {
                e.stopPropagation();
                const authorId = currentUser?.id?.uuid;
                const gigsAssignedFromUser =
                  currentUser?.attributes?.profile?.publicData?.gigsAssigned || [];
                removeWorkerFromListing(currentDBObj);
              }}
            >
              <FormattedMessage id="FieldWorkerJobCateogry.closeJobBtn" />
            </InlineTextButton>
          )}
      </span>
    </div>
  );
}

const mapStateProps = state => {
  const {
    fetchStatusInProgress,
    workerStatus,
    fetchStatusError,
    currentTx,
    removeWorkerInProgress,
  } = state.PendingAcceptanceWorkerCardPage;
  return {
    fetchStatusInProgress,
    workerStatus,
    fetchStatusError,
    currentTx,
    removeWorkerInProgress,
  };
};

const mapDispatchToProps = dispatch => ({
  onfetchWorkerStatus: params => dispatch(fetchWorkerStatus(params)),
});

const PendingAcceptanceWorkerCard = compose(
  connect(
    mapStateProps,
    mapDispatchToProps
  )
)(PendingAcceptanceWorkerCardComponent);

export default PendingAcceptanceWorkerCard;
